import React from 'react';
import { testimonials } from '../data/landing';
import { StarRating } from './StarRating';
export function TestimonialsSection() {
  return <section className="bg-white px-5 py-20" data-id="element-215" data-mp="20qnnnpi6mhol">
      <div className="mx-auto max-w-6xl" data-id="element-216" data-mp="1n0aifuwodh2y">
        <div className="text-center" data-id="element-217" data-mp="1mziv17d8epnr">
          <p className="text-xs font-bold uppercase tracking-[.2em] text-gold-dark" data-id="element-218" data-mp="1r1m983rac8cq">
            Trusted by tennis coaches everywhere
          </p>
          <h2 className="mt-3 font-display text-4xl font-bold uppercase leading-none text-ink sm:text-5xl" data-id="element-219" data-mp="1d133x4e7fge9">
            What coaches are <span className="text-gold-dark" data-id="element-220" data-mp="1i28uowob0tl5">saying</span>
          </h2>
          <p className="mt-3 text-sm font-bold text-slate-600" data-id="element-221" data-mp="142hnpfw7gdgn">
            <StarRating data-id="element-222" data-mp="182i4v8aov2re" /> 4.9/5 · 500+ tennis coaches worldwide
          </p>
        </div>
        <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-223" data-mp="2yf7g1t6xdelx">
          {testimonials.map(({
          initials,
          quote,
          name,
          role
        }) => <figure key={name} className="flex min-h-[250px] flex-col border border-gold-dark/20 bg-ink-wash p-6" data-id="element-224" data-mp="32fhordm3qj4h">
              <div className="flex items-center gap-3" data-id="element-225" data-mp="2q2rccq8im8sy">
                <span className="grid h-10 w-10 place-items-center rounded-full bg-ink text-xs font-bold text-white" data-id="element-226" data-mp="2q1ybu705gfj9">
                  {initials}
                </span>
                <StarRating data-id="element-227" data-mp="2ztc885wt0z86" />
              </div>
              <blockquote className="mt-5 flex-1 text-sm font-medium italic leading-relaxed text-ink" data-id="element-228" data-mp="2zunbm4mc84yr">
                “{quote}”
              </blockquote>
              <figcaption className="mt-5" data-id="element-229" data-mp="274otkt6k983l">
                <p className="text-sm font-bold text-ink" data-id="element-230" data-mp="275zw6po9s9t4">{name}</p>
                <p className="text-xs font-medium text-slate-600" data-id="element-231" data-mp="2m2h8pk873uh9">{role}</p>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}